import Vue from "vue";
import Vuex from "vuex";

import facturacionStore from './facturacion/facturacionStore';
import itemsStore from './items/itemsStore';
import ordersStore from './orders/ordersStore';
import AppQuotesStore from "../views/quotes/AppQuotesStore";
import lineStore from './line/lineStore';
import AppCreditoStore from "./credito/appCreditoStore.js";
// import AppLimiteCreditoStore from "./credito/appLimiteCreditoStore.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    facturacionStore,
    itemsStore,
    ordersStore,
    lineStore,
    AppCreditoStore,
    AppQuotesStore
    // AppLimiteCreditoStore
  },
});